import type mixpanel from 'mixpanel-browser'
import { isElectron } from 'react-device-detect'

type BuildTeacherMixpanelConfigParams = {
  debug: boolean
  isElectronApp: boolean
  isLive: boolean
}

export const isElectronApp = () => isElectron || window.bridge !== undefined
export const buildTeacherMixpanelConfig = ({
  debug,
  isElectronApp,
  isLive,
}: BuildTeacherMixpanelConfigParams) =>
  ({
    track_pageview: true,
    persistence: 'localStorage',
    cookie_name: 'version3',
    cross_subdomain_cookie: false,
    autocapture: {
      click: false,
      pageview: 'url-with-path',
      scroll: true,
      submit: false,
      input: false,
      capture_text_content: false,
    },
    app_host: window.location.hostname,
    debug,
    batch_requests: isLive,
    record_sessions_percent: isElectronApp ? 0 : 10,
    record_mask_text_selector: '.mp-mask',
  }) as Parameters<typeof mixpanel.init>[1]
